import { render, staticRenderFns } from "./CrmAccount.vue?vue&type=template&id=27df7d0c&"
import script from "./CrmAccount.vue?vue&type=script&lang=js&"
export * from "./CrmAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports